import { ApiKey } from '../../domain/apiKey/ApiKey';
import { ApiKeyDTO } from '../../domain/apiKey/ApiKeyDTO';

export class ApiKeyMapper {
  static toDomain(props: ApiKeyDTO): ApiKey {
    const { id, organization_id, label, key, created_at, active } = props;

    return ApiKey.create(
      {
        organization_id,
        label,
        key,
        created_at,
        active,
      },
      id
    );
  }

  static toRepository(props: ApiKey): ApiKeyDTO {
    return {
      id: props.id,
      organization_id: props.organization_id,
      label: props.label,
      key: props.key,
      created_at: props.created_at,
      active: props.active,
    };
  }
}
